import "./css/TextButton.css";

import { Button, type ButtonProps } from "@mui/material";

import { clsx } from "./clsx";
import { disableInput } from "./Utility";

export const TextButton: React.FC<ButtonProps> = ({ className, ...props }) => {
  return (
    <Button
      className={clsx("textButton", className)}
      onMouseDown={disableInput}
      onTouchStart={disableInput}
      variant={"contained"}
      {...props}
    >
      {props.children}
    </Button>
  );
};
